export const BILLING_MONTHLY = 'monthly';
export const BILLING_ANNUALLY = 'annually';

